export default {
  "DNSValidationCard": "_DNSValidationCard_1whu7_1",
  "Grid": "_Grid_1whu7_15",
  "Row": "_Row_1whu7_21",
  "Label": "_Label_1whu7_34",
  "ValueContainer": "_ValueContainer_1whu7_40",
  "CodeBlock": "_CodeBlock_1whu7_47",
  "CopyButton": "_CopyButton_1whu7_56"
};import "ni:sha-256;O0ly7h-MbBV4Xa4X7ay42_bQbZVuBOh0zbrxQ17Qo2k";